import React from 'react';
import PropTypes from 'prop-types';
import { 
	Button,
	CircularProgress,
	Dialog, 
	DialogTitle, 
	DialogContent, 
	DialogActions,
	InputBase,
	MenuItem,
	Select
} from '@material-ui/core';
// import Button from '../widgets/button';
import Form from '../widgets/Form';
import { default as MuiTextField } from '@material-ui/core/TextField';
import {  withStyles } from '@material-ui/core/styles';
import { get } from '../../utils/ajax';
// import SelectField from '../widgets/selectField';
import map from 'lodash/map';
import find from 'lodash/find';
import isFunction from 'lodash/isFunction';
import filter from 'lodash/filter';
import { Link } from 'react-router-dom';
import { commentTemplateReplaceFields } from '../../reducers/progressClaims';

const CustomDialogActions = withStyles((theme) => ({
	root: {
	  position: 'relative'
	},
  }))(DialogActions);

const CustomSelectInput = withStyles((theme) => ({
	root: {
		'label + &': {
			marginTop: theme.spacing(3),
		},
	},
	input: {
		borderRadius: 4,
		border: '1px solid #ced4da',
		position: 'relative',
		padding: '10px 26px 10px 12px',
	},
}))(InputBase);
	
const CommentTemplateEditorDialog = props => {
	const classes = props.classes;
	const [value, setValue] = React.useState('');
	const [template, setTemplate] = React.useState(null);
	const [loading, setLoading] = React.useState(false);
	const [templates, setTemplates] = React.useState([]);

	React.useEffect(() => {
		if (props.show) {
			setValue(props.value);
			setTemplate(null);
			if (!templates || templates.length === 0) loadTemplates();
		}
	}, [props.show]);

	const loadTemplates = () => {
		setLoading(true);
		get({
			url: `/api/progress-claim/comment-templates`,
			onSuccess: data => {
				setTemplates(filter(data, d => d.isActive));
				setLoading(false);
			},
			onError: () => {
				setLoading(false);
			}
		});
	};

	const onClose = () => {
		props.onCancel();
	};
	const onSubmit = () => {
		props.onOk(value);
	}
	
	let selectField = <span style={{ fontStyle: 'italic' }}>No Templates Exist</span>;
	if (loading) {
		selectField = 					
			<div style={{ display: 'inline', verticalAlign: 'middle' }}>
				<CircularProgress
					size={40}
					status="loading"
				/>
			</div>;
	} else if (templates && templates.length > 0) {
		selectField = 
			<Select
				value={template} 
				fullWidth={true}
				label="Use Template" 
				variant="outlined"
				onChange={(e) => {
					setTemplate(e.target.value);
					const t = find(templates, t2 => t2.progressClaimCommentTemplateId === e.target.value);
					if (props.data && t) {
						let comment = t.comment;
						for (let i = 0, ii = commentTemplateReplaceFields.length; i < ii; i++) {
							const f = commentTemplateReplaceFields[i];
							comment = comment.replace(new RegExp(`\\?${f.text}\\?`), isFunction(f.field) ? f.field(props.data) : props.data[f.field]);
						}
						setValue(comment);								
					}
				}}
				MenuProps={{
					style: {
						zIndex: 9990
					},
					getContentAnchorEl: null,
					anchorOrigin: {
						vertical: 'bottom',
						horizontal: 'left',
					}
				}}

				input={<CustomSelectInput />}
				>
				{map(templates, t =>
					<MenuItem 
						key={t.progressClaimCommentTemplateId} 
						value={t.progressClaimCommentTemplateId}
					>
						{t.name}
					</MenuItem>
				)}
			</Select>
	}

	return (
		<Dialog 
			fullWidth={true} 
			maxWidth="lg" 
			open={props.show} 
			onClose={onClose} 
			style={{ zIndex: 9990 }} 
			classes={classes}
			scroll='paper'
		>
			{props.title && <DialogTitle>{props.title}</DialogTitle>}
			<DialogContent style={{ }}>
				<Form 
					onSubmit={onSubmit}
					style={{ }}
				>
					<MuiTextField
						multiline
						variant="outlined"
						minRows={10}
						style={{
							width: '100%',
						}}
						value={value}
						onChange={e => setValue(e.target.value)}
					/>
				</Form>
			</DialogContent>
			<CustomDialogActions>
				<div
					style={{
						position: 'absolute',
						left: '30px',
						top: 0,
						whiteSpace: 'nowrap'
					}}>
					{selectField}
					<Link to={`/progress-claim/comment-templates`} target="_blank" style={{ marginLeft: '10px' }}>Edit Templates</Link>
				</div>

				<Button onClick={onClose}>Cancel</Button>
	 			<Button onClick={onSubmit}>Ok</Button>
			</CustomDialogActions>
		</Dialog>
	);
};

CommentTemplateEditorDialog.propTypes = {
	show: PropTypes.bool,
	onCancel: PropTypes.func.isRequired,
	onOk: PropTypes.func.isRequired,
	value: PropTypes.string.isRequired,
	title: PropTypes.string
};

CommentTemplateEditorDialog.defaultProps = {
	show: false,
	title: null
};

export default CommentTemplateEditorDialog;
